import { APP_INITIALIZER, NgModule } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import {
  BrowserModule,
  provideClientHydration,
} from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  provideHttpClient,
  withFetch,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { AuthGuard } from './guard/auth.guard';
import { ErrorInterceptor } from '../services/ErrorInterceptor.service';
import { IHttpInterceptorService } from '../services/IHttpInterceptorService.service';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { API_BASE_URL, AuthClient, DepartmentsClient, DocumentMetadataClient, DocumentsClient, FoldersClient, IncomingMailClient, MetadataFieldsClient, TagsClient, UsersClient, SenderEntitiesClient, EmployeeClient, SectorsClient, TransactionTypesClient, ActionTypesClient, OutgoingMailClient, FileCategoriesClient } from '../services/ARCDOXservice.service';
import { StorageService } from '../services/StorageService.service';
export function rootLoaderFactory(http: HttpClient) {
   return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

// Loads the translation file before Angular renders anything, so the
// `| translate` pipe never has a window where it falls back to the raw
// key (visible as a flash of "{{ KEY }}"-looking text on first paint).
export function appInitializerFactory(translate: TranslateService, storage: StorageService) {
  return () => {
    const lang = storage.getLanguage() || 'ar';
    translate.setDefaultLang(lang);
    return firstValueFrom(translate.use(lang)).catch(() => {});
  };
}
@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    BsDatepickerModule.forRoot(),
    BrowserAnimationsModule,
     RouterModule.forRoot([]),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: rootLoaderFactory,
                deps: [HttpClient],
            },
        }),
  ],
  providers: [
    // `withInterceptorsFromDi()` keeps the HTTP_INTERCEPTORS registrations below
    // working; without it they are silently ignored.
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    provideClientHydration(),
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [TranslateService, StorageService],
      multi: true,
    },
    AuthGuard,
    AuthClient,
    UsersClient,
    DepartmentsClient,
    FoldersClient,
    DocumentsClient,
    TagsClient,
    MetadataFieldsClient,
    DocumentMetadataClient,
    IncomingMailClient,
    StorageService,
    EmployeeClient,
    SenderEntitiesClient,
    SectorsClient,
    TransactionTypesClient,
    ActionTypesClient,
    OutgoingMailClient,
    FileCategoriesClient,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: IHttpInterceptorService,
      multi: true,
    },
    {
        provide: API_BASE_URL,
        // useValue: 'https://localhost:7042'
      useValue: 'https://nitcotekarcdoxapi.careofme.net'
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
